module.exports = __webpack_public_path__ + "static/media/Map.43b75152.png";